import type { PartnerConfigInput } from "../../config/schema";
import Logo from "./Logo";
import meta from "./meta.json";

// PMPAKET — European delivery partner.
// Logo at ./Logo.tsx, static assets at public/partners/pmpaket/.
//
// Brand uses two linear gradients (per stakeholder spec):
//   primary:   #426db7 → #274067 (blue)
//   secondary: #f6e1a0 → #f0cd72 (gold)
// Phase 1 captures gradient endpoints as single theme tokens. Rendering true
// CSS gradients (e.g. on buttons, brand surfaces) needs gradient-aware tokens
// in src/styles/themes.ts — flagged for follow-up if needed.

const pmpaket = {
  partnerId: "pmpaket",
  apiPartnerId: 39,
  ffidPrefix: "PP",
  appName: "PMPAKET",

  // Shared with server.js, which serves these as crawler-visible head tags.
  meta,

  logo: {
    alt: "PMPAKET",
    Component: Logo,
  },

  theme: {
    light: {
      primary: "#426db7",
      primaryDark: "#274067",
      secondary: "#b45309",
      secondaryLight: "#f6e1a0",
      secondary05: "rgba(180, 83, 9, 0.5)",
      // The partner's amber-brown: white on it is 5.02:1 (on the brighter
      // amber it was 3.19:1).
      buttonPrimary: "#b45309",
    },
    dark: {
      primary: "#426db7",
      // The navy is 1.59:1 on the dark panel; this light blue reads 6.50:1,
      // and 4.95:1 on a pressed button's tint.
      primaryDark: "#7fa3e0",
      secondary: "#b45309",
      secondaryLight: "#f6e1a0",
      secondary05: "rgba(180, 83, 9, 0.5)",
      buttonPrimary: "#b45309",
    },
  },

  chat: {
    provider: "carrot_quest",
    token: "7949-41d0e1276158dd2d851e7e829e5",
  },

  // Mirroring SABO — all features available.
  features: {
    shopify: true,
    tools: true,
    support: true,
    delivery: true,
    mailbox: true,
    addressParsing: true,
    usdtDeposits: false,
    telegramLink: false,
    smsNumbers: false,
  },

  // Mirroring SABO — both payment methods available.
  payments: {
    creditCard: true,
    paypal: true,
    overpay: true,
    stripe: true,
  },

  currency: {
    code: "EUR",
    symbol: "€",
  },

  signup: {
    mode: "open",
    partnerToken: "QWBXICWX",
  },

  // No marketing landing — anonymous "/" keeps redirecting to /signin.
  publicRoot: "signin",

  branches: {
    sbNames: ["USA", "Germany"],
  },

  mailboxes: {
    countries: ["USA", "Germany"],
  },

  api: {
    homeCardsPrefix: "pm_",
  },
} satisfies PartnerConfigInput;

export default pmpaket;
